import { ReactElement } from "react";
import { NewsFeedItem } from "../../../Services/NewsFeeds";

const SUPPORT_MAIL = "mailto:support@worldservicesgroup.com";

interface NewsFeedsStoriesProps {
  loading: boolean;
  unavailable: boolean;
  items: NewsFeedItem[];
}

export default function NewsFeedsStories({ loading, unavailable, items }: NewsFeedsStoriesProps): ReactElement {
  return (
    <div className="news-feeds-stories">
      <h2 className="news-feeds-title">World News</h2>
      {unavailable ? (
        <p className="news-feeds-error">
          This feed is not available. Please contact us at{" "}
          <a href={SUPPORT_MAIL}>support@worldservicesgroup.com</a> for assistance.
        </p>
      ) : null}
      {loading ? <p className="news-feeds-status">Loading news.</p> : null}
      <div className="news-feeds-list">
        {items.map((item, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: item.html }} />
        ))}
      </div>
      <p className="news-feeds-credit">
        News feed provided by <a href="#news-feed-credit">Google News</a>
      </p>
    </div>
  );
}
